/** Resolved once: the platform can't change mid-session. */
function detectMac(): boolean {
  if (typeof navigator === "undefined") return false;
  const uaPlatform = (navigator as any).userAgentData?.platform;
  if (typeof uaPlatform === "string" && uaPlatform) {
    return /mac/i.test(uaPlatform);
  }
  return /mac|iphone|ipad|ipod/i.test(
    navigator.platform || navigator.userAgent || "",
  );
}

const IS_MAC = detectMac();

export const MOD_K = IS_MAC ? "⌘K" : "Ctrl K";
export const MOD_ENTER = IS_MAC ? "⌘↵" : "Ctrl ↵";
export const MOD_SHIFT_ENTER = IS_MAC ? "⌘⇧↵" : "Ctrl ⇧↵";

/**
 * Checks this platform's own modifier, not `metaKey || ctrlKey` — Ctrl+K in a
 * macOS text field is the readline kill-line binding and must not be hijacked.
 */
export function hasModifier(event: {
  metaKey: boolean;
  ctrlKey: boolean;
}): boolean {
  return IS_MAC ? event.metaKey : event.ctrlKey;
}
